
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.46703 7.49967V12.4997C2.46703 16.6663 4.15415 18.333 8.37194 18.333H13.4333C17.6511 18.333 19.3382 16.6663 19.3382 12.4997V7.49967C19.3382 3.33301 17.6511 1.66634 13.4333 1.66634H8.37194C4.15415 1.66634 2.46703 3.33301 2.46703 7.49967Z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14.2769 18.333V1.66634","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8.37192 12.1338L10.5314 10.0005L8.37192 7.86712","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    